import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "react-bootstrap";
import { toast } from "react-toastify";
import CommonHeadingNBtns from "../../common-components/CommonHeadingNBtns";
import { validationHygieneStatusForm } from "../hygiene-common/validation";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import { commonPostPutApi } from "../../../redux/reducers/commonApiSlice";
import {
  add_hygiene_status,
  update_hygiene_status,
} from "../../../data/ApiEndpoints";

const AddHygieneCategoryForm = ({
  userInfoData,
  callFunction,
  isEdit,
  rowData,
  closeModal,
}) => {
  const dispatch = useDispatch();
  const { postPutLoading } = useSelector((state) => state.common);

  const forminitials = {
    statusName: isEdit ? rowData?.name : "",
    statusColor: isEdit ? rowData?.color_hex : "#0d6efd",
    isActive: isEdit && rowData?.status === "active" ? true : false,
    isAutoAddToGymReqForm: isEdit && rowData?.add_gym_req ? true : false,
  };
  const [formValues, setFormValues] = useState(forminitials);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const onChangeInput = (e) => {
    setIsSubmit(false);
    const { name, value, type, checked } = e.target;

    setFormValues((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const onSubmit = () => {
    setFormErrors(validationHygieneStatusForm(formValues));
    setIsSubmit(true);
  };

  const handleAdd = async (payload) => {
    const method = isEdit ? "PUT" : "POST";
    const endpoint = isEdit ? update_hygiene_status : add_hygiene_status;
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        setIsSubmit(false);
        closeModal();
        callFunction();
        toast.success(result?.payload?.message || "Success!");
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      const userData = {
        name: formValues.statusName,
        color_hex: formValues.statusColor,
        add_gym_req: formValues.isAutoAddToGymReqForm ? 1 : 0,
        status: formValues.isActive ? "active" : "inactive",
      };

      if (isEdit) {
        userData.uid = rowData.uid;
      }

      const handleConfirm = async () => {
        handleAdd(userData);
      };

      showConfirmAlert(
        handleConfirm,
        `Check Before Submit.!`,
        "Edit Form",
        `${isEdit ? "Update" : "Add"} Status`
      );
    }
  }, [isSubmit, formErrors]);

  console.log("formValues=> ", formValues);

  return (
    <>
      <CommonHeadingNBtns
        title={`${isEdit ? "Edit" : "Add"} Status`}
        onClose={closeModal}
        btnTxt={isEdit ? "Update" : "Add"}
        onClick={onSubmit}
        isLoading={postPutLoading}
      />

      <form className="formContainer">
        <div className="formInputsGrid twoGridSystem">
          <div className="formInputBox">
            <label htmlFor="statusName" className={`formInputLabel `}>
              status name <span className="required">*</span>
            </label>

            <input
              type="text"
              placeholder="Enter Status name"
              className={`formInput ${
                formErrors?.statusName ? "formError" : ""
              }`}
              name="statusName"
              value={formValues.statusName}
              onChange={onChangeInput}
            />
          </div>

          <div className="formInputBox">
            <label htmlFor="statusColor" className={`formInputLabel `}>
              choose color <span className="required">*</span>
            </label>

            <input
              type="color"
              name="statusColor"
              className={`formInput ${
                formErrors?.statusColor ? "formError" : ""
              } p-0`}
              style={{
                width: "100px",
                border: !formErrors?.statusColor ? "none" : "",
              }}
              value={formValues.statusColor}
              onChange={onChangeInput}
            />
          </div>
        </div>

        <div className="formInputsGrid switchInputs">
          <div
            className={`commonWrapper commonSwitchWrapper no-border ${
              formErrors?.isActive ? "formError" : ""
            }`}
          >
            <Form.Check
              type="switch"
              name="isActive"
              label={`Active`}
              className={`hygine-label ${formValues.isActive ? "active" : ""}`}
              checked={formValues.isActive}
              onChange={onChangeInput}
            />
          </div>

          <div
            className={`commonWrapper commonSwitchWrapper no-border span2 ${
              formErrors?.isAutoAddToGymReqForm ? "formError" : ""
            }`}
          >
            <Form.Check
              type="switch"
              name="isAutoAddToGymReqForm"
              label="Create Ticket"
              // label={`Auto Add To Gym Request Form`}
              className={`hygine-label ${
                formValues.isAutoAddToGymReqForm ? "active" : ""
              }`}
              checked={formValues.isAutoAddToGymReqForm}
              onChange={onChangeInput}
            />
          </div>
        </div>
      </form>
    </>
  );
};

export default AddHygieneCategoryForm;
